<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal customTitle="Gestionar IBANs" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">

    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-4">

        <div formArrayName="ibans" class="space-y-3">
            @for(ibanGroup of ibans.controls; track $index; let i = $index) {
            <div [formGroupName]="i"
                class="p-4 rounded-xl border border-gray-100 bg-gray-50 relative group">

                <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                    <custom-input label="Etiqueta" placeholder="Ej: Cuenta principal" type="text"
                        [formControlItem]="ibanGroup.get('label')">
                    </custom-input>

                    <custom-input label="IBAN" placeholder="ES00 0000 0000 00 0000000000" type="text"
                        [formControlItem]="ibanGroup.get('iban')">
                    </custom-input>
                </div>

                <div class="flex items-center justify-between">
                    <label class="flex items-center gap-2 cursor-pointer">
                        <input type="radio" [checked]="ibanGroup.get('is_primary')?.value"
                            (change)="setPrimary(i)"
                            class="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500">
                        <span class="text-sm text-gray-600">IBAN principal</span>
                        @if(ibanGroup.get('is_primary')?.value){
                        <span
                            class="text-xs bg-indigo-100 text-indigo-700 font-medium px-2 py-0.5 rounded-full">Principal</span>
                        }
                    </label>

                    @if(ibans.length > 1){
                    <button type="button" (click)="removeIban(i)"
                        class="text-red-400 hover:text-red-600 hover:bg-red-50 p-1.5 rounded-lg transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    </button>
                    }
                </div>
            </div>
            }
        </div>

        <button type="button" (click)="addIban()"
            class="w-full py-2 border-2 border-dashed border-indigo-200 text-indigo-500 rounded-xl hover:bg-indigo-50 transition text-sm font-medium">
            + Añadir IBAN
        </button>

    </form>
</app-custom-modal>
}
